import {from} from 'rxjs';
import {map} from 'rxjs/operators';
import { ApiStatusRange, createAppError, ResponseBody } from '../model/api.model';
import { HttpErrorResponse } from '@angular/common/http';


export const mapCidaasResponseToData = <Data>(promise: Promise<ResponseBody<Data>>) => {
  return from(promise)
    .pipe(map((response) => {
      if (ApiStatusRange.Success.checkCode(response.status)) {
        if (response.success) {
          return response.data;
        }
      }
      throw createAppError<Data>(response);
    }));
};



export const createHttpResponseAppError = (error:HttpErrorResponse) => {
  return createAppError(error?.error || {});
};
